"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const mobx_1 = require("mobx");
const locale_1 = require("../../common/js/helper/locale");
const Languages_1 = require("../constants/Languages");
const LocalStorageKeys_1 = __importDefault(require("../enums/LocalStorageKeys"));
const ShopwareCategories_1 = __importDefault(require("./ShopwareCategories"));
const ShopwareNavigation_1 = __importDefault(require("./ShopwareNavigation"));
const TIME_RESOLUTION = 1000;
class UiStore {
    interval = null;
    internalFiveSeconds = new Date(Date.now());
    internalSixtySeconds = new Date(Date.now());
    internalLanguage = Languages_1.DEFAULT_LANGUAGE;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            interval: mobx_1.observable,
            internalFiveSeconds: mobx_1.observable,
            internalSixtySeconds: mobx_1.observable,
            internalLanguage: mobx_1.observable,
            fiveSeconds: mobx_1.computed,
            sixtySeconds: mobx_1.computed,
            language: mobx_1.computed,
            setFiveSeconds: mobx_1.action.bound,
            setSixtySeconds: mobx_1.action.bound,
            setLanguage: mobx_1.action.bound,
        });
    }
    get fiveSeconds() {
        return this.internalFiveSeconds;
    }
    get sixtySeconds() {
        return this.internalSixtySeconds;
    }
    get language() {
        return this.internalLanguage;
    }
    initialize() {
        if (!!this.interval) {
            return;
        }
        this.interval = setInterval(() => {
            const now = new Date(Date.now());
            if (Math.abs(this.fiveSeconds.getTime() - now.getTime()) > 5000) {
                this.setFiveSeconds(now);
            }
            if (Math.abs(this.sixtySeconds.getTime() - now.getTime()) > 60000) {
                this.setSixtySeconds(now);
            }
        }, TIME_RESOLUTION);
    }
    terminate() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
    setupLanguage(locale) {
        const languageCode = (0, locale_1.getLanguageFromLocale)(locale) ?? Languages_1.DEFAULT_LANGUAGE;
        if (i18next_1.default.language !== languageCode) {
            i18next_1.default.changeLanguage(languageCode);
        }
        if (this.internalLanguage !== languageCode) {
            this.setLanguage(languageCode);
            if (ShopwareNavigation_1.default.isInitialized) {
                ShopwareNavigation_1.default.reset();
                ShopwareNavigation_1.default.initialize();
            }
            if (ShopwareCategories_1.default.isInitialized) {
                ShopwareCategories_1.default.reset();
                ShopwareCategories_1.default.initialize();
            }
        }
        if (localStorage.getItem(LocalStorageKeys_1.default.language) !== languageCode) {
            localStorage.setItem(LocalStorageKeys_1.default.language, languageCode);
            document.dispatchEvent(new Event('ZndLanguage'));
        }
    }
    setFiveSeconds(now) {
        this.internalFiveSeconds = now;
    }
    setSixtySeconds(now) {
        this.internalSixtySeconds = now;
    }
    setLanguage(code) {
        this.internalLanguage = code;
    }
}
exports.default = new UiStore();
